import React, { useEffect } from "react";
import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  TableCell,
  TableRow,
} from "@mui/material";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import TableDesign, {
  TableHeading,
} from "../../../../components/common/table/TableDesign";
import { useState } from "react";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import { Lens } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getAllMaterialAction,
  setAddMaterialResponse,
  updateMaterialResponse,
} from "../../../../store/reducers/materialSlice";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import ManageMaterial from "./ManageMaterial";
import DeleteUser from "./DeleteUser";

interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
}

interface Material {
  id: string | number;
  name: string;
  rate: number;
  volume: string;
  is_deletable?: boolean;
}

const MaterialList = () => {
  const tableHeadings: TableHeading[] = [
    { label: "#", align: "left" },
    { label: "Material Name", align: "left" },
    { label: "Rate", align: "left" },
    { label: "Volume", align: "left" },
    // { label: "Status", align: "center" },
    { label: "Action", align: "center" },
  ];
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState<Material | null>(null);
  const openDown = Boolean(anchorEl);
  const [open, setOpen] = useState(false); // State variable to manage dialog open/close
  const [deleteModelShow, setDeleteModelShow] = useState(false);
  const [title, setTitle] = useState("");
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const [filterOption, setFilterOption] = useState<FilterOption>({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
  });

  const { materials, isAddMaterialSuccess } = useSelector(
    (state: any) => state.material
  );

  useEffect(() => {
    dispatch(getAllMaterialAction());
  }, [dispatch]);

  useEffect(() => {
    if (isAddMaterialSuccess) {
      setOpen(false);
      setDeleteModelShow(false);
      setSelectedRow(null);
      setTitle("");
      dispatch(getAllMaterialAction());
      dispatch(setAddMaterialResponse(false));
      dispatch(updateMaterialResponse(false));
    }
  }, [isAddMaterialSuccess]);

  const handleOpen = () => {
    setOpen(true);
    setTitle("Add Material");
  };

  const handleClose = () => {
    setOpen(false);
    setDeleteModelShow(false);
    setSelectedRow(null);
    setTitle("");
    dispatch(setNotificationAction({ message: [], severity: "info" }));
    setAnchorEl(null);
  };

  const handleEditOpen = () => {
    setAnchorEl(null);
    setOpen(true);
    setTitle("Edit Material");
  };
  const handleDeleteOpen = () => {
    setAnchorEl(null);
    setDeleteModelShow(true);
    setTitle("Delete Material");
  };

  return (
    <>
      {deleteModelShow && (
        <DeleteUser
          selectUser={selectedRow}
          alertModalShow={deleteModelShow}
          setAlertModelShow={setDeleteModelShow}
          onHide={handleClose}
        />
      )}
      {open && (
        <ManageMaterial
          open={open}
          onHide={handleClose}
          selectUser={selectedRow}
          title={title}
          isSmallScreen={false} // Assuming this is not used in this component
        />
      )}
      <PageTitle
        title="Material List"
        button="Add Material"
        onClick={handleOpen}
      />
      <Box
        sx={{
          bgcolor: "#fff",
          height: { xs: "auto", sm: "60vh" },
          border: "1px solid #d1cfcf",
          borderRadius: "5px",
          padding: "0px",
          overflow: "hidden",
        }}
      >
        <TableDesign
          tableHeadings={tableHeadings}
          tableHeadColor={"#02906f"}
          cellColor={"#fff"}
          pagination={materials.length > 0 ? null : null}
          isLoader={false}
          stickyHeader={true}
          filterOption={filterOption}
          setFilterOption={setFilterOption}
          extraCSS={{
            height: "calc(100%)",
          }}
        >
          {materials.length > 0 ? (
            materials?.map((val: any, idx: number) => (
              <TableRow
                key={val?.id}
                sx={{
                  cursor: "pointer",
                  marginTop: "10px",
                  padding: "4px !important",
                  borderRadius: "20px !important",
                  "&:hover": {
                    backgroundColor: "#f0f0f0",
                    outline: "2px solid #f0f0f0",
                    borderRadius: "0px !important",
                    outlineOffset: "-2px !important",
                  },
                }}
              >
                <TableCell align="left">{idx + 1}</TableCell>
                <TableCell>{val?.name}</TableCell>
                <TableCell>£ {val?.rate}</TableCell>
                <TableCell align="left">{val?.volume}</TableCell>

                <TableCell align="center" sx={{ padding: "0px" }}>
                  <IconButton
                    sx={{ padding: "0px" }}
                    size="small"
                    id="basic-button"
                    aria-controls={openDown ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openDown ? "true" : undefined}
                    onClick={(e) => {
                      handleClick(e);
                      setSelectedRow(val);
                    }}
                  >
                    <MoreIcon />
                  </IconButton>
                  <Menu
                    sx={{
                      boxShadow: "none",
                      border: "2px solid #eeecef",
                      "& .MuiPaper-root": {
                        boxShadow: "none", // Removes shadow on the paper element of the menu
                        border: "2px solid #eeecef",
                      },
                      top: "0px",
                    }}
                    // className={classes.menuBox}
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={openDown}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={() => handleEditOpen()}>
                      <Lens
                        style={{
                          height: "4px",
                          width: "4px",
                          marginRight: "4px",
                        }}
                      />
                      Edit
                    </MenuItem>

                    {selectedRow?.is_deletable && (
                      <MenuItem onClick={() => handleDeleteOpen()}>
                        <Lens
                          style={{
                            height: "4px",
                            width: "4px",
                            marginRight: "4px",
                          }}
                        />
                        Delete
                      </MenuItem>
                    )}
                  </Menu>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={7}>
                <Box
                  sx={{
                    height: "60vh",
                    display: "flex",
                    // alignItems: "center",
                    justifyContent: "center",
                    position: "relative",
                  }}
                >
                  <span
                    style={{
                      position: "absolute",
                      fontSize: "1rem",
                      color: "#4A4A4A",
                      top: "100px",
                    }}
                  >
                    {"No Materials Found."}
                  </span>
                </Box>
              </TableCell>
            </TableRow>
          )}
        </TableDesign>
      </Box>
    </>
  );
};
export default MaterialList;
